<template>
  <div>
    <Loading v-if="!initialized" />

    <div v-else v-loading="waitLoading">
        <div class="flex-space-between">
          <div>
            <p class="cont-title lf">开标</p>
            <el-input
              v-model="tbdwmc"
              class="input-with-select lf"
              style="width: 250px; margin: 0 10px"
              placeholder="投标单位名称"
              clearable
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="handleSearch"
              />
            </el-input>
          </div>
          <div>
            <!--
            <el-button
              v-if="role == 'Z'"
              type="primary"
              @click="handleSetting"
            >参数设置</el-button>
            -->
            <el-button
              v-if="role == 'T' || role == 'B' || role == 'A'"
              type="primary"
              @click="lookRules"
              :disabled="waitLoading"
            >查看规则</el-button>
            <el-button
              type="primary"
              @click="handleReport"
              >查看竞价公告</el-button>

            <Draw :drawLimit="1" ref="draw" style="margin-left: 10px;" @success="getData" />
          </div>
        </div>

        <draw-bid-concession-rate></draw-bid-concession-rate>
        <div v-if="cscqnrStr" class="mb15">
          <p class="red">{{ cscqnrStr }}</p>
        </div>

        <el-form ref="form" :disabled="role !== 'Z' || !doing">
            <table-tem
              :config="tableConfig"
            >
              <!-- <template #kbsczt="scope">
                <el-form-item
                  :key="`${scope.data.id}-kbsczt`"
                >
                  <el-select
                    v-model="scope.data.kbsczt"
                    class="small"
                    @change="handleChangeSczt(scope.data)"
                  >
                    <el-option
                      v-for="item in scztOptions"
                      :key="item.id"
                      :label="item.label"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </template> -->
              <template #fDTBSJ="scope">
                {{ scope.data.fDTBSJ | format }}
              </template>

              <template #isWinning="scope">
                <i v-if="scope.data.isWinning == 2" class="el-icon-check" />
              </template>

              <template #zbhxr="scope">
                <el-form-item
                  :key="`${scope.data.id}-zbhxr`"
                >
                  <el-select
                    v-model="scope.data.zbhxr"
                    class="small"
                    :disabled="!canSetZbhxr(scope.data)"
                    @change="handleChangeZbhxr(scope.data)"
                  >
                    <el-option
                      v-for="item in zbhxrOptions"
                      :key="item.id"
                      :label="item.label"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </template>

              <!-- <template #remark="scope">
                <el-form-item
                  :key="`${scope.data.id}-remark`"
                  :rules="
                    scope.data.kbsczt === '2'
                      ? [{ required: true, message: '必填项', trigger: 'blur' }]
                      : []
                  "
                >
                  <el-input v-model="scope.data.scyj" placeholder="请输入" @change="handleChangeRemark(scope.data)" />
                </el-form-item>
              </template> -->
            </table-tem>
        </el-form>

        <div v-if="doing && role == 'Z'" class="center">
          <el-button
            class="large"
            type="primary"
            @click="handleNext"
          >下一步</el-button>
        </div>

        <param-setting
          v-if="role == 'Z'"
          ref="paramSetting"
          :project="kbxm"
          :projectType="projectType"
          @success="getCscqnrStr"
        />
    </div>
    <!-- 查看规则弹窗 -->
    <el-dialog
      title="查看规则"
      :visible.sync="showRules"
      width="600px"
      :close-on-click-modal="false"
    >
      <div class="rules">
        <p v-for="(item, index) in rules" :key="index">{{ item }}</p>
      </div>
      <div class="btnBox">
        <el-button type="primary" @click="showRules = false">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import TableTem from '@/components/tableTem';
import Loading from '@/components/loading';
import ParamSetting from './components/ParamSetting';
import DrawStateMixin from '@/mixins/DrawStateMixin.js';
import Draw from '@/components/draw';
import moment from 'moment';
import DrawBidConcessionRate from '@/components/draw/drawBidConcessionRate'

export default {
  name: 'KpytKb',

  label: '开评一体开标节点',

  components: { TableTem, ParamSetting, Draw, Loading, DrawBidConcessionRate },

  mixins: [ DrawStateMixin ],

  data () {
    return {
      initialized: false,
      waitLoading: false,
      tableConfig: {
        head: [
          {
            type: "index",
            title: "序号",
            align: "center",
            width: 60,
          },
          {
            key: "fCQYMC",
            title: "投标单位名称",
            align: "center",
          },
          {
            key: "fDTBSJ",
            title: "报名时间",
            align: "center",
            type: "slot",
            slotName: "fDTBSJ",
          },
          // {
          //   key: "kbsczt",
          //   title: "审查结果",
          //   align: "center",
          //   type: "slot",
          //   slotName: "kbsczt",
          // },
          {
            key: "isWinning",
            title: "抽签结果",
            align: "center",
            type: "slot",
            slotName: "isWinning",
          },
          {
            key: "zbhxr",
            title: "推荐中标候选人",
            align: "center",
            type: "slot",
            slotName: "zbhxr",
          },
          // {
          //   key: "scyj",
          //   title: "备注",
          //   align: "center",
          //   type: "slot",
          //   slotName: "remark",
          // },
        ],
        data: [],
        total: 0,
        currentPage: 1,
        pageSize: 1000,
        border: true,
        hiddenPagination: true,
      },
      scztOptions: [
        { label: "未审查", id: "0" },
        { label: "通过", id: "1" },
        { label: "不通过", id: "2" },
      ],
      zbhxrOptions: [
        { label: "请选择", id: 0 },
        { label: "第一中标候选人", id: 1 },
      ],

      // 数据：部分数据跟其他节点保持一致，参考 yxxsc.vue
      role: localStorage.getItem("role") || 'T',
      djlcId: '', // 当前流程ID，从 url 中获取
      tbdwmc: '', // 投标单位名称
      kbxm: {
        zt: '0'   // 当前节点开标状态，0 未开始，1 开标中，2 已完成
      }, // 开标项目信息
      kbxmlc: {}, // 开标流程信息
      projectType: '', //项目大类1、采购项目 2、工程项目
      cscqnrStr: '', // 参数设置
      showRules: false, // 规则弹框是否展示
      rules: [], // 规则
    }
  },

  computed: {
    waiting() {
      return this.kbxmlc?.zt === '0'
    },
    doing() {
      return this.kbxmlc?.zt === '1'
    },
    done() {
      return this.kbxmlc?.zt === '2'
    },
    canSetZbhxr() {
      return (row) => {
        return false
        // 只有「已通过」才能设置为中标候选人
        // if (row.kbsczt !== '1') return false
        // 只有「被抽中」的才能设置为中标候选人
        if (row.isWinning != 2) return false
        const zbhxr = this.tableConfig.data.find(item => item.zbhxr === 1)
        return !zbhxr || row.id === zbhxr.id
      }
    },
    kbxmId() {
      return this.kbxmlc?.kbxmId || ''
    },
  },

  filters: {
    format(timstamp) {
      return moment(timstamp).format('YYYY-MM-DD HH:mm:ss')
    }
  },

  created () {
    this.djlcId = this.$route.query.djlcId;
    this.initDrawState();
    this.getData();
    this.getProjectType();
    this.getCscqnrStr();
  },

  methods: {
    async getData() {
      try {
        const params = {
          djlcId: this.djlcId,
          tbdwmc: this.tbdwmc,
        };
        const { data } = await this.$api.getKpytList(params);
        this.kbxm = data.data.kbxm;
        this.kbxmlc = data.data.kbxmlc;
        this.tableConfig.data = data.data.tbdwList || [];
        this.tableConfig.total = this.tableConfig.data.length;
        this.initialized = true;
      } catch(err) {
        console.error('getKpytList fail', err);
      }
    },

    async getProjectType() {
      try {
        const { data } = await this.$api.judgeType();
        this.projectType = data.data;
      } catch(err) {
        console.error('getProjectType fail', err);
      }
    },

    async getCscqnrStr() {
      try {
        const { data } = await this.$api.getCscqnrStr();
        if (data.data.cscqnrStr) {
          this.cscqnrStr = data.data.cscqnrStr;
        }
      } catch(err) {
        console.error('getCscqnrStr fail', err);
      }
    },

    handleSearch() {
      this.getData();
    },

    // 查看竞价公告
    async handleReport() {
      const res = await this.$api.noticeView();
      let blob = new Blob([res.data], {
        type: "application/pdf",
      });
      let url = window.URL.createObjectURL(blob);
      window.open(url, "_blank");
    },

    async handleSetting() {
      this.waitLoading = true;
      this.$refs.paramSetting.open();
      this.waitLoading = false;
    },

    // async handleChangeSczt(row) {
    //   this.updateEntInfo(row);
    // },

    async handleChangeZbhxr(row) {
      const { id: tbdwId, zbhxr: px } = row;
      const params = { tbdwId, px };
      try {
        await this.$api.saveZbhxrKpyt(params);
      } catch (err) {
        console.log('saveZbhxrKpyt fail', err);
      }
    },

    // async handleChangeRemark(row) {
    //   this.updateEntInfo(row);
    // },

    // async updateEntInfo(row) {
    //   const params = [
    //     {
    //       bdId: this.kbxm.fgbdid,
    //       kbsczt: row.kbsczt,
    //       scyj: row.scyj,
    //       qyjgdm: row.fCQYJGDM,
    //     },
    //   ];
    //   try {
    //     await this.$api.updateEntInfo(params);
    //   } catch (err) {
    //     console.log('updateEntInfo fail', err);
    //   }
    // },

    async handleNext() {
      // 提交进行下一步
      // this.waitLoading = true;
      // this.$api
      //   .checkCqz()
      //   .then((res) => {
      //     if (res.data.meta.success) {
      //       this.waitLoading = true;
            const param = {
              flag: this.kbxmlc.ycdz
            }
            this.$emit("bxNextBtn", param);
        //   } else {
        //     this.waitLoading = false;
        //     this.$message({
        //       type: "warning",
        //       message: res.data.meta.message,
        //     });
        //   }
        // })
        // .catch((err) => {
        //   this.waitLoading = false;
        //   this.$message({
        //     type: "warning",
        //     message: err.data.meta.message,
        //   })
        // })
    },
    async lookRules() {
      let para = { kbxmId: this.kbxmlc.kbxmId };
      try {
        let res = await this.$api.getPbbfcsByKbxmId(para);
        if (res.status == 200) {
          this.rules = res.data.data;
          this.showRules = true;
        } else {
          this.$message({ type: "error", message: res.message });
        }
      } catch (err) {
        console.log(err);
      }
    },
  }
}
</script>

<style scoped lang='scss'>
.flex-space-between {
  display: flex;
  justify-content: space-between;
}

::v-deep .el-input-group__append,
::v-deep .el-input-group__prepend {
  color: white;
}

.mb15 {
  margin-bottom: 15px;
}

.center {
  text-align: center;
}

.large {
  width: 350px;
  height: 55px;
  line-height: 55px;
  font-size: 20px;

  margin-top: 50px;
}

::v-deep .el-table td.el-table__cell div {
  margin-bottom: 0;
}

.rules {
  p {
    line-height: 24px;
    margin-bottom: 10px;
  }
  margin-bottom: 30px;
}
</style>
